"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _models = require("@knxlab/models");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DATA = [{
  "id": "banc",
  "color": "blue",
  "label": "Banc"
}, {
  "id": "halteres",
  "color": "blue",
  "label": "Haltères"
}, {
  "id": "kettlebell",
  "color": "blue",
  "label": "Kettlebell"
}, {
  "id": "pullupbar",
  "color": "blue",
  "label": "Barre de traction"
}, {
  "id": "weightbar",
  "color": "blue",
  "label": "Barre de musculation"
}, {
  "id": "pilate_elastic",
  "color": "blue",
  "label": "Pilates bandes elastiques"
}, {
  "id": "training_elastic",
  "color": "blue",
  "label": "Training bandes"
}, {
  "id": "mat",
  "color": "blue",
  "label": "Tapis"
}, {
  "id": "abdo_wheel",
  "color": "blue",
  "label": "Roue à abdo"
}, {
  "id": "punchingball",
  "color": "blue",
  "label": "Sac de frappe + gants de boxe"
}, {
  "id": "battle_rope",
  "color": "blue",
  "label": "Battle rope (corde ondulatoire)"
}, {
  "id": "jumping_rope",
  "color": "blue",
  "label": "Corde à sauter"
}, {
  "id": "rings",
  "color": "blue",
  "label": "Anneaux"
}, {
  "id": "parralel_bars",
  "color": "blue",
  "label": "Barres parralèles"
}, {
  "id": "other",
  "color": "blue",
  "label": "Autres"
}];
var schema = {
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    label: {
      type: "string"
    },
    color: {
      type: "string"
    }
  }
};
var NAME = "Equipement";

var Equipement = /*#__PURE__*/function (_AbstractObject) {
  _inherits(Equipement, _AbstractObject);

  var _super = _createSuper(Equipement);

  function Equipement() {
    _classCallCheck(this, Equipement);

    return _super.apply(this, arguments);
  }

  _createClass(Equipement, [{
    key: "getName",
    value: function getName() {
      return NAME;
    }
  }], [{
    key: "getRandomData",
    value: function getRandomData() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var equipement = new Equipement();
      equipement.setData(DATA[index > 0 && index < DATA.length ? index : 0]);
      return equipement;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return DATA.map(function (data, i) {
        return Equipement.getRandomData(i);
      });
    }
  }, {
    key: "getById",
    value: function getById(id) {
      var data = DATA.find(function (equipementData, index) {
        return equipementData.id === id;
      });
      var equipement = new Equipement();
      equipement.setData(data);
      return equipement;
    }
  }]);

  return Equipement;
}(_models.AbstractObject);

exports["default"] = Equipement;
Equipement.register({
  name: NAME,
  schema: schema,
  __class: Equipement
});